export default "__VITE_ASSET__Dn9fE1yV__"